<template>
  <div class="container-fluid new-password">
    <b-container class="h-100 d-flex align-items-center">
      <div class="row d-flex justify-content-center">
        <div class="col-6">
          <div class="form"></div>
          <b-row tag="form" class="form" @submit.prevent="saveNewPassword">
            <b-col cols="12">
              <a class="auth-brand text-center d-block mb-20" href="#">
                <img
                  class="brand-img w-100"
                  src="@/assets/img/odin.png"
                  alt="Diazero Security"
                />
              </a>
            </b-col>
            <b-col cols="12">
              <h1 class="display-5 mb-10 text-center">
                Crie sua nova senha de acesso!
              </h1>
            </b-col>
            <b-col cols="12">
              <p class="mb-30 text-center">
                Para criar uma nova senha de acesso para seu usuário em nosso
                sistema você deverar preencher os 2 campos abaixo com uma nova
                senha.
              </p>
            </b-col>
            <b-col cols="12">
              <div class="form-group">
                Nova senha:
                <input
                  class="form-control"
                  placeholder="Senha"
                  type="password"
                  v-model="password"
                />
                <br />
              <small>
                  <span
                    class="badge mx-1"
                    :class="
                      !$v.password.upperCase
                        ? 'badge-soft-secondary'
                        : 'badge-soft-success'
                    "
                    >1 letra maiuscula</span
                  >
                  <span
                    class="badge mx-1"
                    :class="
                      !$v.password.lowerCase
                        ? 'badge-soft-secondary'
                        : 'badge-soft-success'
                    "
                    >1 minuscula</span
                  >
                  <span
                    class="badge mx-1"
                    :class="
                      !$v.password.number
                        ? 'badge-soft-secondary'
                        : 'badge-soft-success'
                    "
                    >1 número</span
                  >
                  <span
                    class="badge mx-1"
                    :class="
                      !$v.password.special
                        ? 'badge-soft-secondary'
                        : 'badge-soft-success'
                    "
                    >1 caractere especial</span
                  >
                  <span
                    class="badge mx-1"
                    :class="
                      password.length < 12
                        ? 'badge-soft-secondary'
                        : 'badge-soft-success'
                    "
                    >mínimo de 12 caracteres</span
                  >
                  <span
                    class="badge mx-1"
                    :class="
                      !$v.check_password.sameAsPassword
                        ? 'badge-soft-secondary'
                        : 'badge-soft-success'
                    "
                    >senhas iguais</span
                  >
                </small>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="form-group">
                Confirmar Nova senha:
                <input
                  class="form-control"
                  placeholder="Confirmação de senha"
                  type="password"
                  id="newPwdMatch"
                  name="newPwdMatch"
                  v-model="check_password"
                />
              </div>
            </b-col>
            <b-col cols="12">
              <vue-recaptcha
                sitekey="6LfAFfEUAAAAAGl7-UBeTrFv9mHwdiMBAtwyWa87"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                class="d-flex justify-content-center mt-4 mb-4"
              >
              </vue-recaptcha>
            </b-col>
            <b-col cols="12">
              <b-button
                variant="primary"
                type="submit"
                class="w-100"
                :disabled="captch === '' || $v.$invalid"
              >
                Enviar
              </b-button>
            </b-col>
            <b-col cols="12" class="mt-4">
              <p class="text-right">
                <router-link to="/login" tag="a"
                  >Voltar para a tela de login</router-link
                >
              </p>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { mixins } from "@/mixins/mixins";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { upperCase, lowerCase, number, special } from "@/utils/validators"

export default {
  mixins: [mixins],
  async mounted() {
    try {
      this.$store.commit("utils/setLoading", true);
      await api.verifyTokenLostPassword(this.$route.query.token);
    } catch (error) {
      this.swalMessage({
        type: "error",
        title: "Aconteceu um problema",
        text: "Token expirado, favor solicitar nova requisição de senha.",
      });
      this.$router.push("/login");
    } finally {
      this.$store.commit("utils/setLoading", false);
    }
  },
  data() {
    return {
      password: "",
      check_password: "",
      captch: "",
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(12),
      upperCase,
      lowerCase,
      number,
      special
    },
    check_password: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },
  methods: {
    async saveNewPassword() {
      if (this.captch === "" || this.$v.$invalid) return;
      this.$store.commit("utils/setLoading", true);
      let object = {
        pwd1: this.password,
        pwd2: this.check_password,
        token: this.$route.query.token,
      };
      try {
        await api.registerNewPassword(object, this.captch);
        this.swalMessage({
          type: "success",
          title: "Sucesso",
          text: "Senha alterada com sucesso!",
        });
        this.$router.push("/login");
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },
    verifyRecaptcha(e) {
      this.captch = e;
    },
  },
};
</script>
<style  lang="scss">
.new-password {
  height: 100vh;
  .form {
    border-radius: 5px;
    background-color: #fff;
  }
}
</style>